export default "__VITE_ASSET__BW5FYeSm__"